import { View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

import { tableStyles } from '../Table/tableStyles.ts';

type Props = PropsWithChildren<{ wrap?: boolean }>;

export const Tr = ({ wrap, children }: Props) => (
  <View style={tableStyles.tr} wrap={wrap}>
    {children}
  </View>
);
